import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const WorkspaceSettingsPermissionsLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./permissions'),
});
